import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Compass } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { isDirectie } from "@/lib/rollen";
import RondleidingTour from "./RondleidingTour";
import { laadRondleidingen, laadScherm, schermVoorPad } from "./rondleidingApi";

/** Vaste knop 'Rondleiding' op elk scherm (flag rondleiding_v1; directie ziet hem altijd om concepten te bekijken). */
export default function RondleidingKnop() {
  const { user } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [actief, setActief] = useState(null);
  const directie = isDirectie(user);
  useEffect(() => { if (user) laadRondleidingen().then(setData).catch(() => setData(null)); }, [user]);
  const start = useCallback(async () => {
    let d = data;
    try { d = await laadRondleidingen(true); setData(d); } catch { /* laatste stand gebruiken */ }
    const s = schermVoorPad(d?.schermen, loc.pathname);
    if (s) {
      try { setActief(await laadScherm(s.id)); } catch { toast.error("Rondleiding laden mislukt"); }
      return;
    }
    if (directie) toast.info("Voor dit scherm is nog geen rondleiding", { action: { label: "Maak er een", onClick: () => nav(`/rondleiding-beheer?nieuw=${encodeURIComponent(loc.pathname)}`) } });
    else toast.info("Voor dit scherm is nog geen rondleiding");
  }, [data, loc.pathname, directie, nav]);
  useEffect(() => {
    if (!data || !new URLSearchParams(loc.search).has("rondleiding")) return undefined;
    const t = setTimeout(start, 700);
    return () => clearTimeout(t);
  }, [data, loc.search, start]);
  useEffect(() => { setActief(null); }, [loc.pathname]);
  if (!user || !data || (!directie && !data.aan)) return null;
  return (
    <>
      <button onClick={start} title="Rondleiding: uitleg over dit scherm" data-testid="rondleiding-knop"
        className="fixed bottom-[calc(env(safe-area-inset-bottom)+196px)] md:bottom-40 right-4 md:right-6 z-[44] h-11 min-w-11 px-3 rounded-full bg-white text-[#110B09] border border-[#EF3528]/40 shadow-lg flex items-center justify-center gap-1.5 hover:bg-[#EF3528] hover:text-white transition-colors">
        <Compass className="w-5 h-5" /><span className="hidden md:inline text-sm font-medium">Rondleiding</span>
      </button>
      {actief && <RondleidingTour key={actief.id} scherm={actief} user={user} directie={directie} onSluit={() => setActief(null)} />}
    </>
  );
}
